import { useCallback } from "react";

import { useQuery } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

export function useGetUsersOptions() {
  const queryFactory = useCallback(() => {
    const query = `
    query getAdvisors {
      practice {
        advisors(isActive: true) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }`;

    const resolver = ({ data: { practice } }) => {
      return practice.advisors.edges.map(({ node }) => {
        return {
          key: node.id,
          value: node.id,
          text: node.name,
          icon: "user circle",
        };
      });
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { loading, data, error, numOfFetches } = useQuery(queryFactory);

  return {
    loading: loading || (numOfFetches === 0 && !error),
    users: data,
    error: error
      ? error[0]?.message ||
        "Failed to load list of users, please retry or contact support for assistance"
      : "",
  };
}

export default useGetUsersOptions;
